import { Navigate } from "react-router-dom";
import SvgIcons from "../../../../shared/components/svgIcons";
import SkillList from "../components/skillList";
import SkillCreate from "../components/skillCreate";
import SkillEditView from "../components/skillEditView";

const industryRoute = {
  icon: SvgIcons.MasterDataIcon,
  name: "Master Data",
  link: "/master-datas",
  path: "/master-datas",
  element: "",
  index: 990,
  children: [
    {
      path: "skills",
      element: <SkillList />,
      name: "Skills",
      permission: "Skill",
      index: 3,
      link: "master-datas/skills",
      icon: SvgIcons.JobTitleIcon,
    },
    {
      path: "skills/create",
      element: <SkillCreate />,
    },
    {
      path: "skills/:id",
      element: <SkillEditView />,
    },
    {
      path: "",
      element: <Navigate to="master-datas/skills" replace />,
    },
  ],
};
export default industryRoute;
